import React from "react";

const COIN_SRC = "/assets/currency-coin.png";

type CareerStatCardHeaderProps = {
  iconSrc: string;
  title: string;
  /** Pre-formatted coins string, e.g. "+28,025" or "+1,200" */
  coinsLabel: string;
};

/**
 * Single flex row with items-center so sign and digits share one vertical center.
 * Anton’s +/− sit low in the em box; translate up so they optically match the digits.
 */
function CoinsLabelWithSign({ label }: { label: string }) {
  const first = label[0];
  if (first === "+" || first === "-") {
    return (
      <span className="inline-flex items-center gap-px whitespace-nowrap text-right font-anton font-normal text-white [leading-trim:none]">
        <span className="inline-block shrink-0 translate-y-[-0.14em] text-[18px] leading-none tracking-normal">
          {first}
        </span>
        <span className="inline-block min-w-0 text-[10px] leading-none tracking-normal tabular-nums">
          {label.slice(1)}
        </span>
      </span>
    );
  }
  return (
    <span className="whitespace-nowrap text-right font-anton text-[10px] font-normal uppercase leading-[12px] tracking-normal tabular-nums text-white [leading-trim:none]">
      {label}
    </span>
  );
}

/** Career stat card top bar: game icon + name (left), coins value + coin icon (right). */
export function CareerStatCardHeader({ iconSrc, title, coinsLabel }: CareerStatCardHeaderProps) {
  return (
    <div className="flex min-h-[26px] items-center justify-between gap-3 bg-[#652DAF] px-2 py-0.5">
      <span className="flex min-w-0 flex-1 items-center gap-1.5">
        <img
          src={iconSrc}
          alt=""
          className="h-4 w-4 shrink-0 object-contain"
          loading="lazy"
          decoding="async"
        />
        <span className="min-w-0 truncate font-anton text-[12px] font-normal uppercase leading-[12px] tracking-normal text-white [leading-trim:none]">
          {title}
        </span>
      </span>
      <span className="flex shrink-0 items-center justify-end gap-1 text-right">
        <CoinsLabelWithSign label={coinsLabel} />
        <img src={COIN_SRC} alt="" className="h-3.5 w-3.5 shrink-0 object-contain" aria-hidden />
      </span>
    </div>
  );
}

export const CAREER_STAT_ICONS = {
  spin: "/assets/spinner.png",
  trader: "/assets/trader.png",
  squares: "/assets/squares.png",
  bullion: "/assets/bullion.png",
  sixes: "/assets/sixes.png",
  leagues: "/assets/league-trophy.png",
  quickfire: "/assets/quickfire_square.png",
} as const;
